import { fetchWithAuth } from '../lib/fetchWithAuth';

const API_BASE_URL = import.meta.env.VITE_API_URL?.replace(/\/$/, '');

export type ModerationStatus = 'pending_review' | 'flagged' | 'approved' | 'rejected';

export type AdminModerationJob = {
  id: number | string;
  title: string;
  employerName: string;
  status: ModerationStatus;
  reports: number;
  description: string;
  submittedAt: string;
};

const mockJobs: AdminModerationJob[] = [
  {
    id: 1,
    title: 'Senior Care Assistant',
    employerName: 'Caring Hands',
    status: 'pending_review',
    reports: 2,
    description: 'Lead inclusive care teams in London. Requires NVQ Level 3.',
    submittedAt: '2025-11-12T10:00:00Z',
  },
  {
    id: 2,
    title: 'Healthcare Support Worker',
    employerName: 'Northbridge Care',
    status: 'flagged',
    reports: 1,
    description: 'Support community clinic shifts with flexible hours.',
    submittedAt: '2025-11-11T16:30:00Z',
  },
  {
    id: 3,
    title: 'Care Coordinator',
    employerName: 'Harbor Wellness',
    status: 'rejected',
    reports: 3,
    description: 'Oversee night-shift assignments. Requires safeguarding certifications.',
    submittedAt: '2025-11-10T08:10:00Z',
  },
];

export async function fetchAdminModerationJobs(status?: ModerationStatus) {
  if (!API_BASE_URL) {
    throw new Error('VITE_API_URL is required to load moderation jobs.');
  }
  const params = new URLSearchParams();
  if (status) params.set('status', status);
  const response = await fetchWithAuth(`${API_BASE_URL}/v1/admin/jobs?${params.toString()}`);
  if (!response.ok) {
    const errorText = await response.text().catch(() => '');
    throw new Error(`Moderation fetch failed (${response.status}): ${errorText}`);
  }
  const payload = await response.json();
  return (payload?.jobs as AdminModerationJob[]) ?? [];
}

export async function updateAdminModerationJob(id: number | string, status: ModerationStatus, note?: string) {
  if (!API_BASE_URL) {
    throw new Error('VITE_API_URL is required to update moderation jobs.');
  }
  const response = await fetchWithAuth(`${API_BASE_URL}/v1/admin/jobs/${id}/status`, {
    method: 'POST',
    body: JSON.stringify({ status, note }),
  });
  if (!response.ok) {
    const errorText = await response.text().catch(() => '');
    throw new Error(`Moderation action failed (${response.status}): ${errorText}`);
  }
  return (await response.json()) as AdminModerationJob;
}
